import moment from 'moment';
import Constants from "./Constants";
import Time from "./Time";

const Intervention = {

  requiresRedFlag(intervention) {
    // 2h59 = 2
    // 3h00 = 3
    const redFlagLimit = Time.diffFromNow(intervention.previousWorkingDayClosingTime) < 3;
    return this.isTypeAppointment(intervention) && redFlagLimit && (this.isNotApproved(intervention) || this.isOpen(intervention));
  },

  duringWorkingHours(intervention) {
    const {journey: {properties = {}} = {}} = intervention;
    const {dropOff} = properties.reception;
    return dropOff.duringWorkingHours;
  },

  fastLane(intervention) {
    const {journey: {properties = {}} = {}} = intervention;
    const {dropOff} = properties.reception;
    return dropOff.fastLane;
  },

  getDisplayOrigin(origin, brand) {
    if (origin !== 'OAS') {
      return origin;
    }
    return `${origin}.` + (brand === 'MINI' ? brand : 'BMW');
  },

  isNotApproved(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_NOT_APPROVED.value;
  },

  isCallCenter(intervention) {
    return intervention.origin === 'CALL_CENTER';
  },

  isWeb(intervention) {
    return intervention.origin === 'WEB';
  },

  isOngoing(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_ONGOING.value;
  },

  isAfterEndDate(intervention) {
    const {endDate} = intervention;
    return moment().isAfter(endDate);
  },

  isComplete(intervention) {
    return this.isOngoing(intervention) || this.isAfterEndDate(intervention);
  },

  isConfirmed(intervention) {
    const {journey: {status} = {}} = intervention;
    return status === 'CONFIRMED';
  },

  isWaitingForClient(intervention) {
    const {journey: {status} = {}} = intervention;
    return status === 'WAITING_CONFIRMATION';
  },

  isVehicleReady(intervention) {
    const {journey: {properties: {reception = {}} = {}} = {}} = intervention;
    return Object.keys(reception).includes('pickUp');
  },

  hasPickupOutsideWorkingHours(intervention) {
    const {journey: {properties: {reception = {}} = {}} = {}} = intervention;
    // comparison with boolean in order to make sure the property 'duringWorkingHoursChoice' exists
    return reception.pickUp && reception.pickUp.outsideWorkingHoursOffer === true;
  },

  isWaitingAtDealership(intervention) {
    if (!Intervention.isTypeAppointment(intervention)){
      return true;
    }
    const {journey: {properties: {mobility = {}} = {}} = {}} = intervention;
    return mobility.mobility === 'wait';
  },

  isTypeMessage(intervention) {
    const {journey} = intervention;
    return !journey || journey.type === Constants.TYPE_MESSAGE.value;
  },

  isTypeAppointment(intervention) {
    const {journey} = intervention;
    return journey && journey.type === Constants.TYPE_APPOINTMENT.value;
  },

  isTypeTiresAndWheels(intervention) {
    const {journey} = intervention;
    return journey && journey.type === Constants.TYPE_TIRES.value;
  },

  isArchived(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_ARCHIVED.value;
  },

  isCancelled(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_CANCELLED.value;
  },

  isDeleted(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_DELETED.value;
  },

  isFinished(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_FINISHED.value;
  },

  isOpen(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_OPEN.value || status === Constants.STATUS_OPEN_48.value;
  },

  hasEndStatus(intervention) {
    return Intervention.isFinished(intervention) || Intervention.isCancelled(intervention) || Intervention.isDeleted(intervention) || Intervention.isArchived(intervention);
  },

  isOAS(intervention) {
    return intervention.origin === 'OAS';
  }

};

export default Intervention;



// WEBPACK FOOTER //
// ./src/services/Intervention.js